const NAME = "MY_BENEFITS_PAGE";

export default NAME;
